




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class HiddenField extends Vue {
  @Prop() name!: string;
  @Prop() value!: number;
}
